import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { concatMap, finalize, mergeMap, tap } from 'rxjs/operators';

import { AuthService } from '../../../services/auth.service';
import { ChiefsOrderService } from '../../../services/chiefsOrder.service';
import { LoaderService } from '../../../common/services/loader.service';
import { SubHeaderService } from '../../../core/services/sub-header.service';

import { coReviewViewModel } from '../../../models/comodel/coreviewviewmodel.model';
import { SubHeader } from '../../../core/models/sub-header.model';
import { ChiefsOrderInstance, chiefsOrderReviewStatus, ChiefsOrderStatus, levelContext } from '../../../models/comodel/chiefsorderdetailsmodel.model';
import { Note } from "../../../common/models/note.model";
import { NoteType } from "../../../common/models/note-type.enum";
import { DocumentManagementService, IUploadFile } from '../../../common/services/document-management.service';
//import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { Dialog, DialogButton } from '../../../core/models/dialog.model';
import { DynamicDialogService } from '../../../core/services/dynamic-dialog.service';
import { SidePanel } from '../../../common/models/side-panel.model';
import { GenerateReportModel } from '../../../reports/model/reports.model';
import { StateType } from '../../../flow/models/flow.model';
import { FormControl, FormGroup } from '@angular/forms';
import { LayoutService } from '../../../layouts/services/layout.service';
import { ReportSelectorService } from '../../../form-controls/services/report-selector.service';
import { SidePanelService } from '../../../common/services/side-panel.service';
import { FlowHistoryService } from '../../../flow/services/flow-history.service';
import { ChiefsOrderSearchSpec } from '../../../models/comodel/chiefs-order-search-spec.model';
import { LettersService } from '../../../letters/letters.service';
import { Letter, LetterSearchCriteria, LetterStatus } from '../../../letters/letters.model';
import { DatePipe } from '@angular/common';
import { CommitProvisionedFileWithKeywordsRequest } from '../../../common/models/onBaseIntegrationAndMapping.model';
import { ChiefOrderPostIssueOptions, ChiefsOrderMergeConstants, ReportTemplate } from '../../../models/comodel/mergefieldsmodel.model';
import { CommunicationType } from '../../components/communications/communication-template-editor.component';
import { EntryType, FlowHistory, HistoryType } from '../../../common/models/flow.dto';
import { deepClone } from '../../../builder/models/editor.model';
import { UploadViewFilesComponent } from '../../../common/components/fileUpload/upload-view-files.component';
//import { AllModules, ColDef, GridOptions, IDateFilterParams } from '@ag-grid-enterprise/all-modules';
import { ColDef, GridOptions, IDateFilterParams } from "ag-grid-community";
import { GridFormatterService } from '../../../common/services/grid-formatter.service';
import { RouterLinkRendererComponent } from '../../../common/components/ag-grid/router-link-renderer.component';
import { dateComparator, dateFilterComparator } from '../../../common/components/data-table/comparators/data-table.comparators';
import { LunaClaimValues } from '../../../models/user-identity.model';
import { SystemNotificationService } from '../../../notifications/system-notifications/services/system-notification.service';
import { SystemNotification, SystemNotificationLevel } from '../../../notifications/system-notifications/models/system-notification.model';

@Component({
    selector: 'co-details',
    templateUrl: './co-details.component.html',
    styleUrls: ['./co-details.component.scss'],
    standalone: false
})
export class CoDetailsComponent implements OnInit, OnDestroy {

    gridOptions: GridOptions;

    @ViewChild("downloadLink") public downloadLink: ElementRef;
    @ViewChild(UploadViewFilesComponent) public _uploadViewFilesElement: UploadViewFilesComponent;

    confirmFileDeleteDialog: Dialog = new Dialog("Are you sure you want to delete this file?", [new DialogButton("Delete the file", true, () => this.onFileDeleteConfirm()), new DialogButton("Cancel", true, () => { })]);
    confirmSubmittalDialog: Dialog = new Dialog("The Chief's Order was successfully submitted to the next level of review.", [new DialogButton("OK", true, () => this.onSubmittalDialogConfirm())]);
    confirmRejectionDialog: Dialog = new Dialog("The Chief's Order was rejected by the current review group.", [new DialogButton("OK", true, () => this.onRejectionDialogConfirm())]);
    confirmPostIssueActionDialog: Dialog = new Dialog("The Chief's Order was rejected by the current review group.", [new DialogButton("Confirm", true, () => this.onPostIssueActionDialogConfirm()), new DialogButton("Cancel", true, () => { })]);
    confirmManualStatusChangeDialog: Dialog = new Dialog("Are you sure you want to manually change the status of this Chief's Order.", [new DialogButton("Confirm", true, () => this.onConfirmManualStatusChange()), new DialogButton("Cancel", true, () => { })]);

    displayDetails: boolean = true;
    coInstanceId: string = '';
    statusEnum = LetterStatus;
    coContext: levelContext = {postIssueFiles: [], notes: [] };
    chiefsOrderInstance: ChiefsOrderInstance;
    relatedChiefsOrderInstance: ChiefsOrderInstance = null;
    selectedChiefOrderPostIssueOptionPrettyText: string;
    postIssueOptions = ChiefOrderPostIssueOptions;
    postIssueFinalStatus: ChiefsOrderStatus
    reportTemplate: ReportTemplate;
    postIssueActionReport: ReportTemplate ;
    allTemplates: ReportTemplate[];
    allChiefsOrderTemplates: ReportTemplate[];
    filteredChiefsOrderTemplates: ReportTemplate[];
    allAssociatedLetters: Letter[];
    letter: Letter;
    approveText: string = '';
    userIsInternal: boolean = false;
    userCanManuallyChangeStatus: boolean = false;
    displayManualStatusChangeDetails: boolean = false;
    manualStatusToSet: string = "";
    manualStatusChangeButtonText: string = "Manually Change Status";
    notesDisplayHeader: string = "Further Notes:";
    validStatusesForManualStatusSet: ChiefsOrderStatus[] = [ChiefsOrderStatus.Appealed, ChiefsOrderStatus.Modified, ChiefsOrderStatus.Vacated, ChiefsOrderStatus.Suspended, ChiefsOrderStatus.Revoked, ChiefsOrderStatus.Terminated]

    get status(): string {
        if (this.chiefsOrderInstance)
            return this.chiefsOrderInstance.status;
        else
            return "";
    }

    get issuedDate(): string {
        if (this.chiefsOrderInstance && this.coContext.data && this.coContext.data.signature)
            return this.datePipe.transform(this.coContext.data.signature.dateSigned);
        else
            return "Not Issued";
    }

    get mostRecentStatusChangeDate(): string {
        if (this.chiefsOrderInstance)
            return this.datePipe.transform(this.chiefsOrderInstance.lastUpdatedTime);
        else
            return "N/A";
    }

    get letterDeliveryStatus(): string {
        if (this.letter) {
            switch (this.letter.status) {
                case LetterStatus.Delivered: {
                    return 'Delivered';
                }
                case LetterStatus.Pending: {
                    return 'Pending';
                }
                case LetterStatus.Returned: {
                    return 'Returned';
                }
                case LetterStatus.Sent: {
                    return 'Sent';
                }
                case LetterStatus.Unknown: {
                    return 'Unknown';
                }
            };
        }
        else
            return "Unknown";
    }

    get letterDeliveryDate(): any {
        if (this.letter && this.letter.deliveryDate)
            return this.letter.deliveryDate;
        else
            return "Not Yet Delivered";
    }

    get filesToShow(): IUploadFile[] {
        if (this.coContext && this.coContext.postIssueFiles)
            return this.coContext.postIssueFiles;
        else
            return [];
    }
    fileToDelete: IUploadFile;
    blobStr: any;
    pathStr: string;

    get title(): string {
        if (this.coContext && this.coContext.data) return this.coContext.data.templateName;
        return "";
    }
    currentPage: number = 1;
    pdfAvailable: boolean = false;
    pdfData: any;
    pdfUrl: string;
    subscription = new Subscription();
    form: FormGroup = new FormGroup({
        updatedContents: new FormControl('')
    });
    showRejectButton: boolean = false;
    notesText: string = '';
    isInternalVal: boolean = false;
    saveBlob: any;
    public activeSidePanel: SidePanel;
    private reportModel: GenerateReportModel = {
        useBanner: true,
        usePageNumberHeader: true,
        formatAsLetter: true,
        headerOnFirstPage: false,
        htmlHeader: "",
        html: "",
        htmlFooter: "",
        styleMergeFields: true
    } as GenerateReportModel;
    showError: boolean = false;
    totalPages: number = 0;
    private _isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    get isLoading$(): Observable<boolean> {
        return this._isLoading$.asObservable();
    }

    subHeader: SubHeader = new SubHeader({ title: this.title, buttons: [{ name: "View Notes & Timeline", method: () => this.showNotesAndTimeline() }] });

    public sidePanelWithoutFieldNotes: SidePanel = new SidePanel({
        tabs: [{ title: "Review Notes", stateTypeRequired: StateType.ReviewForm }, { title: "Timeline", stateTypeRequired: StateType.ReviewForm }],
        sections: [{ componentName: 'ReviewNotesCommon', componentData: null, method: (event) => this.noteReplied(event) }, { componentName: 'Timeline', componentData: [] }]
    });
    currentView: string;

    constructor(
        private activeRoute: ActivatedRoute,
        public _authService: AuthService,
        private chiefsOrderService: ChiefsOrderService,
        private letterService: LettersService,
        public dialogService: DynamicDialogService,
        private docMgmtSrvc: DocumentManagementService,
        public layoutService: LayoutService,
        private readonly loader: LoaderService,
        public reportService: ReportSelectorService,
        private router: Router,
        public sidePanelService: SidePanelService,
        private subHeaderService: SubHeaderService,
        private flowHistoryService: FlowHistoryService,
        private datePipe: DatePipe,
        private readonly formatterService: GridFormatterService,
        public notificationService: SystemNotificationService,
	) {
	}

    ngAfterContentInit() {
    }

    ngOnInit() {
        this.userIsInternal = this._authService.User.isInternal;
        this.userCanManuallyChangeStatus = this._authService.User.allClaims.filter(a => a.value == LunaClaimValues.ManuallySetChiefsOrderStatus).length > 0;
        this.coContext = {} as levelContext;
        this.loader.toggleLoader(true);
        this.coInstanceId = this.activeRoute.snapshot.params["coinstanceid"];
        this.currentView = this.router.url.split('/')[3].split('co-')[1];
        this.loadData(this.coInstanceId);

        if (this.userIsInternal)
            this.setSubheader();

        this.layoutService.update('ChiefsOrders');
        this.activeSidePanel = this.sidePanelWithoutFieldNotes;
        this.sidePanelService.newSidePanel(this.activeSidePanel);

        let coldefs = this.createColumnDefinitions();
        this.gridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(coldefs, false, true, true, true);
    }

    ngOnDestroy(): void {
        if (this.subscription)
            this.subscription.unsubscribe();
    }

    createColumnDefinitions(): ColDef[] {
        return [
            {
                headerName: "Recipient",
                headerTooltip: "Recipient",
                field: "recipientName",
                tooltipField: "recipientName",
                filter: "agTextColumnFilter",
                cellRenderer: RouterLinkRendererComponent,
                cellRendererParams: {
                    idField: "id",
                    textField: "recipientName",
                    url: "/letters"
                },
            },
            {
                headerName: "Organization",
                headerTooltip: "Organization",
                field: "organizationName",
                tooltipValueGetter: this.formatterService.formatPotentiallyBlankField("organizationName", "Unknown"),
                valueGetter: this.formatterService.formatPotentiallyBlankField("organizationName", "Unknown"),
                filter: "agTextColumnFilter"
            },
            {
                headerName: "Description",
                headerTooltip: "Description",
                field: "title",
                tooltipValueGetter: this.formatterService.formatPotentiallyBlankField("title", "Unknown"),
                valueGetter: this.formatterService.formatPotentiallyBlankField("title", "Unknown"),
                filter: "agTextColumnFilter"
            },
            {
                headerName: "Sent",
                headerTooltip: "Sent",
                field: "sentDate",
                tooltipValueGetter: this.formatterService.formatDate("sentDate"),
                valueGetter: this.formatterService.formatDate("sentDate"),
                comparator: dateComparator,
                filter: "agDateColumnFilter",
                filterParams: { browserDatePicker: true, comparator: dateFilterComparator, includeTime: false, buttons: ['reset'] } as IDateFilterParams,
                sort: "desc",
                sortingOrder: ["asc", null, "desc"],
            },
            {
                headerName: "Mailing Type",
                headerTooltip: "Mailing Type",
                field: "mailType",
                tooltipField: "mailType",
                filter: 'agSetColumnFilter',
            },
            {
                headerName: "Status",
                headerTooltip: "Status",
                field: "letterStatus",
                tooltipValueGetter: this.statusFormatter(this),
                valueGetter: this.statusFormatter(this),
                filter: 'agSetColumnFilter',
            },
            {
                headerName: "Tracking Number",
                headerTooltip: "Tracking Number",
                field: "trackingNumber",
                tooltipValueGetter: this.trackingNumberFormatter(this),
                valueGetter: this.trackingNumberFormatter(this),
                filter: "agTextColumnFilter"
            }
        ];
    }

    statusFormatter(component: any) {
        return (obj) => component.statusEnum[obj.data.status];
    }

    trackingNumberFormatter(component: any) {
        return (obj) => { return (obj.data.isCertified) ? obj.data.trackingNumber : "n/a"; };
    }

    setSubheader(): void {
        this.subHeaderService.updateSubHeader(this.subHeader);
    }

    showNotesAndTimeline(): void {
        this.sidePanelService.toggleSidePanel(true);
    }

    loadData(instance: string): void {
        this.manualStatusToSet = ""
        this.notesDisplayHeader = "Further Notes:";
        this.manualStatusChangeButtonText = "Manually Change Status";
        this.displayManualStatusChangeDetails = false;
        let chiefsOrderNumberExists = false;
        const chiefsOrderInstance$ = this.chiefsOrderService.getChiefsOrderInstances({ Id: this.coInstanceId } as ChiefsOrderSearchSpec).pipe(tap((matchingInstances) => {
            this.chiefsOrderInstance = matchingInstances[0];
            chiefsOrderNumberExists = this.stringIsValid(this.chiefsOrderInstance.chiefsOrderNumber);
        }),
            mergeMap(() => {

                if (chiefsOrderNumberExists)
                    return this.chiefsOrderService.getChiefsOrderInstances({ priorChiefsOrderNumber: this.chiefsOrderInstance.chiefsOrderNumber } as ChiefsOrderSearchSpec);
                else
                    return of([]);
            }),
            mergeMap((relatedChiefsOrderInstances) => {
                if (relatedChiefsOrderInstances && relatedChiefsOrderInstances.length > 0) {
                    this.relatedChiefsOrderInstance = relatedChiefsOrderInstances[0];
                }
                return this.reportService.getAllTemplates();
            }),
            concatMap((reportTemplates) => {
                this.allTemplates = reportTemplates;
                this.reportTemplate = this.allTemplates.filter(a => a.id == this.chiefsOrderInstance.reportTemplateId)[0];
                //filter the templates down to chiefs order ones of the same category for use in post issue actions
                this.allChiefsOrderTemplates = this.allTemplates.filter(a => a.typeCode.toLowerCase() === CommunicationType.ChiefOrder);

                return this.chiefsOrderService.getChiefsOrderContext(instance);
            }),
            mergeMap((contents) => {
                this.coContext = contents;
                //Set it to last review
                this.reportModel.mergeFields = this.coContext.data.fields;
                this.reportModel.usePageNumberHeader = this.coContext.reviews[this.coContext.reviews.length - 1].letter.usePageNumberHeader;
                this.reportModel.html = this.coContext.reviews[this.coContext.reviews.length - 1].letter.htmlContent;
                this.reportModel.htmlHeader = this.coContext.reviews[this.coContext.reviews.length - 1].letter.htmlHeader;
                this.reportModel.htmlFooter = this.coContext.reviews[this.coContext.reviews.length - 1].letter.htmlFooter;
                this.sidePanelService.updateSectionData("ReviewNotesCommon", this.coContext.notes);

                if (this.userIsInternal)
                    this.setSubheader();

                //Fetch all sent and delivered letters related to this chief's order
                if (chiefsOrderNumberExists)
                    return this.letterService.find({ inStatuses: [LetterStatus.Pending, LetterStatus.Sent, LetterStatus.Delivered], chiefsOrderNumber: this.chiefsOrderInstance.chiefsOrderNumber } as LetterSearchCriteria);
                else if (this.stringIsValid(this.chiefsOrderInstance.letterId))
                    return this.letterService.get(this.chiefsOrderInstance.letterId);
                else
                    return of([]);
            }),
            concatMap((letters) => {
                if (!Array.isArray(letters))
                    letters = [letters];

                this.allAssociatedLetters = letters;
                //Now figure out which letter is the original one for this chief's order instance
                let matchingLetters = this.allAssociatedLetters.filter(a => a.id == this.chiefsOrderInstance.letterId);

                if (matchingLetters.length > 0)
                    this.letter = this.allAssociatedLetters.filter(a => a.id == this.chiefsOrderInstance.letterId)[0];

                if (this.letter && this.letter.pdfDocumentId != null) {
                    return this.docMgmtSrvc.getStoredDocument(this.letter.documentTypeId, this.letter.pdfDocumentId).pipe(
                        tap((pdf) => {
                            this.pdfUrl = window.URL.createObjectURL(pdf);
                            this.pdfData = pdf;
                        })
                    );
                }
                else
                {
                    if (this.reportModel.html && this.reportModel.html !== "") {
                        return this.reportService.generate(this.reportModel).pipe(
                            tap((blob) => {
                                if (blob) {
                                    this.pdfUrl = window.URL.createObjectURL(blob);
                                    this.pdfData = blob;
                                }
                            })
                        );
                    } else {
                        return of(null);
                    }
                }

            }))
            .subscribe((data) => {
                this.pdfAvailable = data !== null;
                this.loader.toggleLoader(false);
                this._isLoading$.next(false);
                finalize(() => { this.subscription.add(chiefsOrderInstance$); })
            },
            (error) => {
                console.error(error);
                this.showError = true;
                this.loader.toggleLoader(false);
            });

        const flowHistory$ = this.flowHistoryService.getDetailedFlowInstanceHistory(this.coInstanceId).subscribe((detailedFlowHistory) => {
            this.sidePanelService.updateSectionData("Timeline", detailedFlowHistory)
            finalize(() => { this.subscription.add(flowHistory$); })
        }, (error) => {
            console.error(error);
            this.showError = true;
        });
    }

    download(): void {
        const blob = new Blob([this.pdfData], { type: "application/pdf" });
        const fileName = `Chief's Order ` + this.chiefsOrderInstance.chiefsOrderNumber + `.pdf`;
		const url = URL.createObjectURL(blob);
		const link = this.downloadLink.nativeElement;
		link.href = url;
		link.download = fileName;
		link.click();
    }

    nextPage(): void {
        if (this.currentPage >= this.totalPages) return;
        this.currentPage++;
    }

    onLoadComplete(pdf: any): void {
        this.totalPages = pdf.numPages;
    }

    previousPage(): void {
        if (this.currentPage <= 1) return;
        this.currentPage--;
    }

    addReviewNote(): void {
        const note = {
            documentType: "Note",
            isDeleted: false,
            createdDate: undefined,
            createdById: this._authService.User.id,
            createdBy: this._authService.User.displayName,
            type: (this.isInternalVal) ? NoteType.Internal : NoteType.General,
            text: this.notesText
        } as Note;
        this.coContext.notes.push(note);
        this.saveNotes();
    }

    savedFiles($event: IUploadFile) {
        var newFile = $event;
        this.filesToShow.push(newFile);
    }

    saveNotes(): void {
        this.loader.toggleLoader(true);
        const res$ = this.chiefsOrderService.savereviewnote({ instanceId: this.coContext.id, notes: this.coContext.notes } as coReviewViewModel).pipe(finalize(() => {
            this.notesText = '';
            this.isInternalVal = false;
        })).subscribe(x => {
            console.log(x);
            this.coContext = x;
            this.sidePanelService.updateSectionData("ReviewNotesCommon", this.coContext.notes);
            this.loadData(this.coInstanceId);
        }, (error) => {
            console.log(error);
            this.loader.toggleLoader(false);
        });
        this.subscription.add(res$)
    }

    public hasFileListing(): boolean {
        return this.filesToShow.length > 0 ? true : false;
    }
    public allowFileDeletion(file: IUploadFile): boolean {
        if (file && file.canBeDeleted != undefined && file.canBeDeleted != null)
            return file.canBeDeleted;
        else
            return true;
    }

    deleteFile($event: IUploadFile) {
        this.fileToDelete = $event;
        this.confirmFileDeleteDialog.message = `Are you sure you want to delete this file?`;
        this.confirmFileDeleteDialog.toggleDialog(true);
        this.dialogService.updateDialog(this.confirmFileDeleteDialog);
    }

    downloadFile($event: IUploadFile) {
        var file = $event;
        const download$ = this.docMgmtSrvc.downloadFile(file.blobUri).pipe(
            tap((data) => {
                const link = this.downloadLink.nativeElement;
                link.href = data;
                link.click();
            }),
            finalize(() => {
                this.subscription.add(download$);
            })
        ).subscribe(() => { });
    }

    noteReplied(notes: Note[]): void {
        this.coContext.notes = notes;
        this.saveNotes();
    }

    public setCurrentView(viewName: string): void {
        this.currentView = viewName;
    }

    public onFileDeleteConfirm() {
        this.loader.toggleLoader(true);

        var abandon$ = this.docMgmtSrvc.abandon(this.fileToDelete)
            .pipe(finalize(() => {
                this.subscription.add(abandon$);
            }))
            .subscribe(() => {
                const index = this.filesToShow.findIndex(x => x.blobUri === this.fileToDelete.blobUri);
                if (index !== -1)
                    this.filesToShow.splice(index, 1);

                //Now make sure the file got removed from the upload-view-files component too
                this._uploadViewFilesElement.removeFile(this.fileToDelete);
            }, (error) => { console.error(error); });

        var delete$ = this.chiefsOrderService.deleteFilesFromContext(this.fileToDelete, this.coInstanceId)
            .pipe(finalize(() => {
                this.subscription.add(delete$);
                this.loader.toggleLoader(false);
            }))
            .subscribe((result) => {
                this.loader.toggleLoader(true);
                const index = this.filesToShow.findIndex(x => x.blobUri === this.fileToDelete.blobUri);
                if (index !== -1)
                    this.filesToShow.splice(index, 1);
                console.log('file was deleted: ', this.fileToDelete.fileName);
                this.loadData(this.coInstanceId);
            }, (error) => { console.error(error); });
    }

    public onSubmittalDialogConfirm() {
        this.router.navigate(['/home']);
    }

    public onRejectionDialogConfirm() {
        this.router.navigate(["/dashboard/view/ricsDashboard"]);
    }

    public canSendToOnbase() {
        return this.hasFileListing && this.coContext.postIssueFiles && this.coContext.postIssueFiles.filter(a => !a.sentToOnbase).length > 0;
    }

    public sendToOnBase() {

        let filesToCommit: CommitProvisionedFileWithKeywordsRequest[] = [];

        let filesNotInOnbaseAlready = this.coContext.postIssueFiles.filter(a => !a.sentToOnbase);
        for (let x = 0; x < filesNotInOnbaseAlready.length; x++) {
            filesToCommit.push({
                documentTypeName: "DNR - OG - LCO-Chief's Order - Additional", //"DNR - OG - Chief's Order - Additional",
                keywordValues: this.coContext.onBaseKeywords,
                provisionedFile: filesNotInOnbaseAlready[x] as IUploadFile
            } as CommitProvisionedFileWithKeywordsRequest);
        }

        this.loader.toggleLoader(true);

        let sendFilesToOnbase$ = this.docMgmtSrvc.commitProvisionedFilesToOnBase(filesToCommit).pipe(tap((OnBaseIds) => {
            for (let x = 0; x < filesNotInOnbaseAlready.length; x++) {
                filesNotInOnbaseAlready[x].canBeDeleted = false;
                filesNotInOnbaseAlready[x].sentToOnbase = true;
            }
        }),
            mergeMap(() => {
                return this.chiefsOrderService.saveChiefsOrderContext(this.coContext)
            })).subscribe((data) => {
                this.loader.toggleLoader(false);
                finalize(() => { this.subscription.add(sendFilesToOnbase$); })
            },
                (error) => {
                    this.loader.toggleLoader(false);
                    console.error(error);
                    this.showError = true;
                });
        
    }

    canPerformAtleastOnePostIssueAction(): boolean {
        if (this.reportTemplate && this.reportTemplate.chiefsOrderPostIssueOptions && this.reportTemplate.chiefsOrderPostIssueOptions.length > 0
            && !this.aBlockingExistingPostIssueActionExists()) {
            return true;
        }
        else return false;
    }

    aBlockingExistingPostIssueActionExists(): boolean {
        if (this.relatedChiefsOrderInstance != null && parseInt(this.relatedChiefsOrderInstance.currentLevelNumber) >= 2
            && this.relatedChiefsOrderInstance.reviewStatus != chiefsOrderReviewStatus.Cancelled && this.relatedChiefsOrderInstance.reviewStatus != chiefsOrderReviewStatus.Rejected) {
            return true;
        }
        else return false;
    }

    public postIssueActionPrettyName(option: ChiefOrderPostIssueOptions): string {
        switch (option) {
            case ChiefOrderPostIssueOptions.Appeal: {
                return 'Appeal';
            }
            case ChiefOrderPostIssueOptions.Modify: {
                return 'Modify';
            }
            case ChiefOrderPostIssueOptions.Revoke: {
                return 'Revoke';
            }
            case ChiefOrderPostIssueOptions.Suspend: {
                return 'Suspend';
            }
            case ChiefOrderPostIssueOptions.Terminate: {
                return 'Terminate';
            }
            case ChiefOrderPostIssueOptions.Vacate: {
                return 'Vacate';
            }
        };
    }

    canPerformPostIssueAction(option: ChiefOrderPostIssueOptions): boolean {
        if (this.chiefsOrderInstance && this.reportTemplate && this.reportTemplate.chiefsOrderPostIssueOptions
            && this.canPerformAtleastOnePostIssueAction()) {
            return this.reportTemplate.chiefsOrderPostIssueOptions.filter(a => a.typeOfPostIssueOption == option).length > 0;
        }
        else return false;
    }

    isCurrentlyIssued(): boolean {
        if (this.chiefsOrderInstance)
            return this.chiefsOrderInstance.status == ChiefsOrderStatus.Issued;
        else
            return false;
    }

    public kickOffAppeal() {

        this.chiefsOrderInstance.status = ChiefsOrderStatus.Appealed;
        this.chiefsOrderInstance.lastUpdatedTime = new Date(new Date().toUTCString());
        this.chiefsOrderInstance.lastUpdatedByUserId = this._authService.User.id;
        this.chiefsOrderInstance.lastUpdatedByDisplayName = this._authService.User.displayName;

        this.loader.toggleLoader(true);

        const saveInstance$ = this.chiefsOrderService.saveChiefsOrderInstance(this.chiefsOrderInstance).pipe(
            concatMap((data) => {
                let historyObj = {
                    instanceId: this.chiefsOrderInstance.id,
                    entryType: EntryType.ChiefsOrderAppealed,
                    type: HistoryType.Flow,
                    organizationId: this._authService.User.organizationId,
                    userId: this._authService.User.id,
                    workOrderId: ""
                } as FlowHistory;
                return this.flowHistoryService.saveHistory(historyObj);
            }),
            concatMap((result) => {
                return this.flowHistoryService.getDetailedFlowInstanceHistory(this.coInstanceId)
            }),
            tap((detailedFlowHistory) => {
                this.sidePanelService.updateSectionData("Timeline", detailedFlowHistory)
            }),
            finalize(() => {
                this.subscription.add(saveInstance$);
            })
        ).subscribe(() => {
            this.loader.toggleLoader(false);
        }, (error) => { console.error(error); this.loader.toggleLoader(false); });
    }

    public kickOffPostIssueAction() {
        this.router.navigate(['/admin/chief-orders/co-level-mergefields', this.postIssueActionReport.id, this.chiefsOrderInstance.organizationId, this.postIssueActionReport.categoryCode, this.chiefsOrderInstance.chiefsOrderNumber, this.postIssueFinalStatus]);
    }

    public cancelPostIssueAction() {
        this.displayDetails = true;
        this.postIssueActionReport = null;
        this.selectedChiefOrderPostIssueOptionPrettyText = null;
    }

    public onPostIssueActionDialogConfirm() {
        //Toggle View of post issue action templates to pick
        this.displayDetails = false;
    }
    private stringIsValid(value: string): boolean {
        let stringExists = (value != null && value != undefined && value != "");
        return stringExists;
    }

    public kickOffNonAppealPostIssueAction(typeOfAction: ChiefOrderPostIssueOptions) {

        this.filteredChiefsOrderTemplates = deepClone(this.allChiefsOrderTemplates);
        switch (typeOfAction) {
            case ChiefOrderPostIssueOptions.Appeal:
                this.selectedChiefOrderPostIssueOptionPrettyText = "Appealing";
                this.postIssueFinalStatus = ChiefsOrderStatus.Appealed;
                break;
            case ChiefOrderPostIssueOptions.Modify:
                this.selectedChiefOrderPostIssueOptionPrettyText = "Modification";
                this.postIssueFinalStatus = ChiefsOrderStatus.Modified;
                break;
            case ChiefOrderPostIssueOptions.Revoke:
                this.selectedChiefOrderPostIssueOptionPrettyText = "Revocation";
                this.postIssueFinalStatus = ChiefsOrderStatus.Revoked;
                break;
            case ChiefOrderPostIssueOptions.Suspend:
                this.selectedChiefOrderPostIssueOptionPrettyText = "Suspension";
                this.postIssueFinalStatus = ChiefsOrderStatus.Suspended;
                break;
            case ChiefOrderPostIssueOptions.Terminate:
                this.selectedChiefOrderPostIssueOptionPrettyText = "Termination";
                this.postIssueFinalStatus = ChiefsOrderStatus.Terminated;
                this.filteredChiefsOrderTemplates = this.filteredChiefsOrderTemplates.filter(a => a.categoryCode == "TER");
                break;
            case ChiefOrderPostIssueOptions.Vacate:
                this.selectedChiefOrderPostIssueOptionPrettyText = "Vacating";
                this.postIssueFinalStatus = ChiefsOrderStatus.Vacated;
                this.filteredChiefsOrderTemplates = this.filteredChiefsOrderTemplates.filter(a => a.categoryCode == "VAC");
                break;
        }

        this.confirmPostIssueActionDialog.message = `Are you sure you want to ` + this.postIssueActionPrettyName(typeOfAction) + ` this Chief's Order #` + this.chiefsOrderInstance.chiefsOrderNumber + `?`;
        this.confirmPostIssueActionDialog.toggleDialog(true);
        this.dialogService.updateDialog(this.confirmPostIssueActionDialog);
    }

    toggleDisplayOfManualStatusChangeDetails() {
        this.displayManualStatusChangeDetails = !this.displayManualStatusChangeDetails;
        if (this.displayManualStatusChangeDetails) {
            this.manualStatusChangeButtonText = "Cancel Manual Changing of Status";
            this.notesDisplayHeader = "*Modification Reason:";
        }
        else {
            this.manualStatusChangeButtonText = "Manually Change Status";
            this.notesDisplayHeader = "Further Notes:";
            this.notesText = "";
        }
    }

    toggleManuallyChangeStatusDialog() {
        this.confirmManualStatusChangeDialog.toggleDialog(true);
        this.dialogService.updateDialog(this.confirmManualStatusChangeDialog);
    }

    onConfirmManualStatusChange() {
        this.loader.toggleLoader(true);
        //First submit the note
        const note = {
            documentType: "Note",
            isDeleted: false,
            createdDate: undefined,
            createdById: this._authService.User.id,
            createdBy: this._authService.User.displayName,
            type: (this.isInternalVal) ? NoteType.Internal : NoteType.General,
            text: this.notesText
        } as Note;
        this.coContext.notes.push(note);

        const res$ = this.chiefsOrderService.savereviewnote({ instanceId: this.coContext.id, notes: this.coContext.notes } as coReviewViewModel).pipe(tap((context) => {
            this.coContext = context;
            this.sidePanelService.updateSectionData("ReviewNotesCommon", this.coContext.notes);
            this.notesText = '';
            this.isInternalVal = false;
            }),
            concatMap((x) => {
                this.chiefsOrderInstance.status = this.manualStatusToSet;
                this.chiefsOrderInstance.lastUpdatedByDisplayName = this._authService.User.displayName;
                this.chiefsOrderInstance.lastUpdatedByUserId = this._authService.User.id;
                this.chiefsOrderInstance.lastUpdatedTime = new Date(new Date().getUTCDate());
                this.chiefsOrderInstance.statusLastUpdatedDate = new Date(new Date().getUTCDate());
                return this.chiefsOrderService.saveChiefsOrderInstance(this.chiefsOrderInstance);
            }),
            concatMap((saveChiefsOrderInstanceResult) => {
                let historyObj = {
                    instanceId: this.chiefsOrderInstance.id,
                    organizationId: this._authService.User.organizationId,
                    userId: this._authService.User.id,
                    type: HistoryType.Flow,
                    workOrderId: ""
                } as FlowHistory;

                switch (this.manualStatusToSet) {
                    case ChiefsOrderStatus.Appealed: {
                        historyObj.entryType = EntryType.ChiefsOrderAppealed;
                        break;
                    }
                    case ChiefsOrderStatus.Modified: {
                        historyObj.entryType = EntryType.ChiefsOrderModified;
                        break;
                    }
                    case ChiefsOrderStatus.Revoked: {
                        historyObj.entryType = EntryType.ChiefsOrderRevoked;
                        break;
                    }
                    case ChiefsOrderStatus.Suspended: {
                        historyObj.entryType = EntryType.ChiefsOrderSuspended;
                        break;
                    }
                    case ChiefsOrderStatus.Terminated: {
                        historyObj.entryType = EntryType.ChiefsOrderTerminated;
                        break;
                    }
                    case ChiefsOrderStatus.Vacated: {
                        historyObj.entryType = EntryType.ChiefsOrderVacated;
                        break;
                    }
                };
                return this.flowHistoryService.saveHistory(historyObj);
            }),
            concatMap((saveHistory) => {
                //If the user isn't a member of any of the legal groups, send a notification about the order being changed
                if (this._authService.User.groups.filter(a => a == "nWOOnV3nWOOQu41KlR" || a == "p2x6jh1p2xc4oFr~d" || a == "p2x6jh3p2xckix0sHS" || a == "p2x6jh2p2xcdao0i8G").length == 0) {
                    let notificationText = "A Change has been made to the status of " + this.chiefsOrderInstance.chiefsOrderNumber + " " + this.chiefsOrderInstance.organizationName + " " + this.chiefsOrderInstance.organizationId + ", by " + this._authService.User.displayName + ".";
                    let notification = {
                        applicationNumber: this.chiefsOrderInstance.applicationNumber,
                        description: notificationText,
                        level: SystemNotificationLevel.Information,
                        flowId: this.chiefsOrderInstance.id,
                        groupId: "nWOOnV3nWOOQu41KlR",
                        orgId: "0002",
                        timestamp: new Date().toLocaleDateString(),
                        type: "General",
                    } as SystemNotification
                    return this.notificationService.createNotification(notification);
                }
                else
                    return of(null);
            }),
        ).subscribe(x => {
            console.log(x);
            this.loadData(this.coInstanceId);
        }, (error) => {
            console.log(error);
            this.loader.toggleLoader(false);
        });
        this.subscription.add(res$)
    }
}
